export default "__VITE_ASSET__DZaGAyrX__"